import { motion } from "framer-motion";

const Title = () => {
    return(
        <motion.div 
          initial={{opacity:0}} 
          animate={{opacity: 1}}
          transition={{duration: 0.5, delay: 1}}
          className="project-name">Mr.Chu 🌤️ Weather
        </motion.div>
    )
}

export default Title